import { useMutation, UseMutationOptions } from "@tanstack/react-query";
import axiosInstance from "axiosConfig";
import { Toast } from "shared";
import { TOAST_TYPES_ENUM } from "enums";
// import { queryClient } from "App";
import { queryClient } from "App";

export const useDeactivateSubscription = (
  options?: UseMutationOptions<any, Error, string>
) => {
  return useMutation({
    ...options,
    mutationKey: ["deactivateSubscription"],
    mutationFn: async (customerUuid) => {
      return axiosInstance
        .delete(`/subscriptions?customer_uuid=${customerUuid}`)
        .then((res) => res.data);
    },
    onMutate: (variables) => {
      Toast({
        message: "Ładowanie...",
        type: TOAST_TYPES_ENUM.LOADING,
        id: "delete-subscription",
      });
    },
    onSuccess: (data, variables, context) => {
      queryClient.invalidateQueries({ queryKey: ["subscriptions"] });
      queryClient.invalidateQueries({ queryKey: ["customers"] });
      Toast({
        message: "Subskrypcja została wyłączona.",
        type: TOAST_TYPES_ENUM.SUCCESS,
        id: "delete-subscription",
      });
      if (options && options.onSuccess) {
        options.onSuccess(data, variables, context);
      }
    },
    onError: (error, variables, context) => {
      Toast({
        message: "Wystąpił błąd podczas wyłączania subskrypcji.",
        type: TOAST_TYPES_ENUM.ERROR,
        id: "delete-subscription",
      });
      if (options && options.onError) {
        options.onError(error, variables, context);
      }
    },
  });
};

export default useDeactivateSubscription;
